import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(() => ({
  logo: {
    marginTop: '48px'
  },
  progress: {
    marginBottom: '72px',
    maxWidth: '320px',
    width: '100%',
    marginTop: '16px'
  },
  title: {
    marginTop: '16px',
    fontWeight: '500',
    color: '#333'
  },
  waitText: {
    color: '#666',
    fontSize: '12px'
  }
}))
